






















































import Vue, { PropType } from "vue";
import _ from "lodash";
import moment from "moment";
import { DateRangeTypeEnum } from "@/model/data/dashboard/DateRangeTypeEnum";
import { TransactionTypeEnum, transactionTypeEnumLabel } from "@/model/data/enums/TransactionTypeEnum";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { mapActions, mapGetters, mapState } from "vuex";
import { GET_WORKLOAD_CURRENCIES } from "@/store/modules/InstallationsWorkloadModule/actions";
import { RootState } from "@/store";
export default Vue.extend({
    data() {
        return { DateRangeTypeEnum };
    },
    computed: {
        ...mapGetters(["userDateFormat"]),
        ...mapState({
            currencies: (state: RootState): string[] => state.installationWorkload.currencies,
        }),
        dateRange: {
            get() {
                var res = [];
                if (this.widget.filter.startDate)
                    res.push(
                        moment(this.widget.filter.startDate)
                            .toISOString()
                            .substr(0, 10)
                    );
                if (this.widget.filter.endDate)
                    res.push(
                        moment(this.widget.filter.endDate)
                            .toISOString()
                            .substr(0, 10)
                    );
                return res;
            },
            set(v: any) {
                if (v.length == 1) {
                    this.widget.filter.startDate = new Date(v[0]);
                    this.widget.filter.endDate = null;
                } else {
                    const a = new Date(v[0]);
                    const b = new Date(v[1]);
                    if (a < b) {
                        this.widget.filter.startDate = a;
                        this.widget.filter.endDate = b;
                    } else {
                        this.widget.filter.startDate = b;
                        this.widget.filter.endDate = a;
                    }

                    this.widget.filter.endDate.setUTCHours(23);
                    this.widget.filter.endDate.setUTCMinutes(59);
                    this.widget.filter.endDate.setUTCSeconds(59);
                }
            },
        },
        availableDynamicDateRange() {
            return [
                { value: 1, text: this.$tc("common.day", 1, { count: 1 }) },
                { value: 7, text: this.$tc("common.day", 7, { count: 7 }) },
                { value: 15, text: this.$tc("common.day", 15, { count: 15 }) },
                { value: 30, text: this.$tc("common.month", 1, { count: 1 }) },
                { value: 90, text: this.$tc("common.month", 3, { count: 3 }) },
            ];
        },
        availableTransactionTypes() {
            return Object.values(TransactionTypeEnum)
                .filter((v) => !isNaN(Number(v)))
                .map((v) => ({
                    text: this.$t(transactionTypeEnumLabel(v as TransactionTypeEnum)),
                    value: v,
                }));
        },
        availableDateRangeType() {
            var res = [];

            res.push({
                text: this.$t("dashboard.widget_transactions.date_range_type.dynamic"),
                value: DateRangeTypeEnum.Dynamic,
            });

            res.push({
                text: this.$t("dashboard.widget_transactions.date_range_type.fixed"),
                value: DateRangeTypeEnum.Fixed,
            });

            return res;
        },
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    methods: {
        ...mapActions([GET_WORKLOAD_CURRENCIES]),
        startDateText(widget) {
            return moment(widget.filter.startDate).format(this.userDateFormat);
        },
        endDateText(widget) {
            return moment(widget.filter.endDate).format(this.userDateFormat);
        },
    },
    mounted() {
        if (!this.currencies || !this.currencies.length) this[GET_WORKLOAD_CURRENCIES]();
    },
});
